"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exportToCsv;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _downloadjs = _interopRequireDefault(require("downloadjs"));
var _exceljs = _interopRequireDefault(require("exceljs"));
var _csvExportFormatter = _interopRequireDefault(require("./csvExportFormatter"));
var _exportUtil = require("../exportUtil");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var encode = (0, _defineProperty2.default)((0, _defineProperty2.default)({}, 'utf-8-bom', function utf8Bom(_ref) {
  var buffer = _ref.buffer;
  /**
   * https://unicode.org/faq/utf_bom.html#bom1
   */
  if (!buffer || !buffer.length) return undefined;
  var bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  return new Blob([bom, buffer]);
}), 'utf-8', function utf8(_ref2) {
  var buffer = _ref2.buffer;
  return (0, _exportUtil.bufferToBlob)(buffer);
});
function writeBufferAndDownload(wb, fileName, encodingType) {
  var options = {
    delimiter: ';'
  };
  return wb.csv.writeBuffer(options).then(function (buffer) {
    var blob = encode[encodingType]({
      buffer: buffer
    });
    if (!blob) {
      Promise.reject('Error creating blob.');
      return false;
    }
    var result = (0, _downloadjs.default)(blob, "".concat(fileName, ".csv"), 'text/csv');
    if (result === false) {
      Promise.reject('Error downloading generated file.');
    }
    return result;
  });
}
function getTitle(col) {
  return typeof col.csvTitle === 'string' ? col.csvTitle : col.title;
}
function prepareHeader(columns) {
  return columns.map(function (col) {
    return getTitle(col);
  });
}
function getValue(row, col) {
  var value = (0, _exportUtil.getValueByPath)(row, col.dataIndex);
  if (typeof col.csvRender === 'function') {
    return col.csvRender(value, row);
  }
  if (typeof col.type === 'string') {
    return _csvExportFormatter.default[col.type] ? _csvExportFormatter.default[col.type](_objectSpread(_objectSpread({}, col), {}, {
      value: value
    })) : _csvExportFormatter.default.default({
      value: value
    });
  }
  return !!value || value === 0 ? String(value) : '';
}
function prepareBody(columns, data) {
  var flatData = (0, _exportUtil.flatten)(data);
  return flatData.map(function (row) {
    return columns.map(function (col) {
      return getValue(row, col);
    });
  });
}
function prepareData(wb, columns, data) {
  var ws = wb.addWorksheet();
  var preparedHeader = prepareHeader(columns);
  ws.addRow(preparedHeader);
  var preparedBody = prepareBody(columns, data);
  ws.addRows(preparedBody);
}
function exportToCsv(options) {
  var columns = options.columns,
    _options$data = options.data,
    data = _options$data === void 0 ? [] : _options$data,
    _options$filename = options.filename,
    filename = _options$filename === void 0 ? 'export' : _options$filename,
    _options$encodingType = options.encodingType,
    encodingType = _options$encodingType === void 0 ? 'utf-8' : _options$encodingType;
  var wb = new _exceljs.default.Workbook();
  prepareData(wb, columns, data);
  return writeBufferAndDownload(wb, filename, encodingType);
}